import React from 'react';
import { formatNumber } from 'utils/formatter';

type Props = {
  classNames: string;
  noValueText?: string;
  numberOfDecimal?: number;
  unit?: string;
  value: number | null;
  withPlusSign?: boolean;
};

const NumberLabel: React.FC<Props> = props => {
  const withPlusSign = !!props.withPlusSign;
  const numberOfDecimal = props.numberOfDecimal ?? 0;

  return (
    <div className={props.classNames}>
      {formatNumber(props.value, {
        noValueText: props.noValueText,
        numberOfDecimal: numberOfDecimal,
        withPlusSign: withPlusSign,
      })}
      {props.unit && <div className="unit">{props.unit}</div>}
    </div>
  );
};

export default NumberLabel;
